import { OnInput } from "../../../library-js/dom-tools/EventListeners";

export class InputFieldElement extends HTMLInputElement
{
  protected _initializedAsInputFieldElement:boolean;
  _cachedValues:string[];
  _expressionValue:string;
  _computedValue:string;

  _getLastNonEmptyValue():string
  {
    for ( let i = 0; i < this._cachedValues.length; i++ )
    {
      let last = this._cachedValues.length - 1;
      let iterationIndex = last - i;
      
      if ( this._cachedValues[ iterationIndex ] !== "" )
      {
        return this._cachedValues[ iterationIndex ];
      }
    }

    return null;
  }
  

  

  static get( e:HTMLInputElement ):InputFieldElement
  {
    let ife = e as InputFieldElement;

    if ( ife._initializedAsInputFieldElement )
    {
      return ife;
    } 

    ife._cachedValues = ["","","","",""];

    

    OnInput.add( ife,
      ( e )=>
      {
        ife._cachedValues.push( ife.value );

        if ( ife._cachedValues.length > 5 )
        {
          ife._cachedValues.shift();
        }

        console.log( e.type, ife._cachedValues, ife.value, e, ife );
      }
    );

    ife._initializedAsInputFieldElement = true;

    return ife;
  }
}